import { useTranslate } from '../../customHooks';
import { Card, CardHeader, CardBody, Sheet, SheetBody, Button } from "@panwds/react-ui";
import { FirewallGeneralInfo, SecurityPolicies, EndpointManagement } from './Components/Create';
import { useCreateFirewallMutation } from '../../redux/services/firewalls-service'
import { toast } from '../../components';
import { useFilteredPermissions } from '../../customHooks/useFilteredPermissions';
import { FormProvider, useForm } from "react-hook-form";
import { SubmitButton } from '@panwds/react-form';
import { isEmpty } from 'lodash';

export const FirewallCreate = (props: any) => {
    const { close, loading, handleCreateCallback } = props;
    const translate = useTranslate();
    const [createFirewall, { isLoading }] = useCreateFirewallMutation();

    const initialValues = {
        PolicyManaged: 'Rulestack', // Default value for PolicyManaged
        RuleStackName: 'Default Rulestack' // Default value for RuleStackName
    };

    const formMethods = useForm({ defaultValues: initialValues || {} });
    const {
        formState: { dirtyFields }, control, setValue, watch
    } = formMethods

    const region = watch('Region');
    const onSubmit = async (values: any, form: any) => {
        const { FirewallName, Region, AllowListAccounts, PolicyManaged, RuleStackName, CMLinkId, ...rest } = values;

        // Create the updated firewall details object
        const updatedFirewallDetails = {
            ...rest,
            ...(AllowListAccounts && {
                AllowListAccounts: Array.isArray(AllowListAccounts) ?
                    AllowListAccounts : AllowListAccounts?.split(",")
            }),
            ...(FirewallName && { Tags: [{ Key: 'FirewallName', Value: FirewallName }] }),
            ...(PolicyManaged === "Rulestack" && RuleStackName !== "Default Rulestack" && { RuleStackName }),
            ...(CMLinkId && { LinkId: CMLinkId }), // Rename CMLinkId to LinkId
        };

        try {
            const result = await createFirewall({
                newFirewallDetails: updatedFirewallDetails,
                region: Region,
            }).unwrap();
            if(result){
                handleCreateCallback(result);
                close(); // Close the sheet on successful creation
            }
            
        } catch (error: any) {
            toast.error(`${error?.code}: ${error?.error}`, { toastId: "create-firewall" });
        }
    };

    return (
        <>
            <Sheet
                onClose={() => close()}
                title={translate(`resources.firewallsV2.create`)}
                isOpen
                showMask={true}
                position="md"
            >
                <SheetBody isLoading={loading}>
                    <FormProvider {...formMethods}>
                        <form onSubmit={formMethods.handleSubmit(onSubmit)}>
                            <div>
                                <div className='tw-mb-4'>
                                    <Card>
                                        <CardHeader title={translate(`resources.firewallsV2.generalInfo`)} />
                                        <CardBody>
                                            <FirewallGeneralInfo setValue={setValue} control={control}/>
                                        </CardBody>
                                    </Card>
                                </div>
                                <div className='tw-mb-4'>
                                    <Card>
                                        <CardHeader title={translate(`resources.firewallsV2.policyManager`)} />
                                        <CardBody>
                                            <SecurityPolicies region={region} setValue={setValue} control={control} />
                                        </CardBody>
                                    </Card>
                                </div>
                                <div className='tw-mb-4'>
                                    <Card>
                                        <CardHeader title={translate(`resources.firewallsV2.endpointManagement.title`)} />
                                        <CardBody>
                                            <EndpointManagement />
                                        </CardBody>
                                    </Card>
                                </div>
                            </div>
                            <div className="tw-flex tw-justify-end">
                                <Button addClassName="tw-mr-2" onClick={() => close()}
                                    dataMetrics="cloudngfw-firewall-create-cancel">
                                    {translate('generic.close')}
                                </Button>
                                <SubmitButton disabled={isLoading || isEmpty(dirtyFields)} dataMetrics="cloudngfw-firewall-create-save">
                                    {translate('generic.create')}
                                </SubmitButton>
                            </div>
                        </form>
                    </FormProvider>
                </SheetBody>
            </Sheet>
        </>
    );
};
